import { render, staticRenderFns } from "./RfDataGraph.vue?vue&type=template&id=9667611c&scoped=true"
import script from "./RfDataGraph.vue?vue&type=script&lang=js"
export * from "./RfDataGraph.vue?vue&type=script&lang=js"
import style0 from "./RfDataGraph.vue?vue&type=style&index=0&id=9667611c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9667611c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9667611c')) {
      api.createRecord('9667611c', component.options)
    } else {
      api.reload('9667611c', component.options)
    }
    module.hot.accept("./RfDataGraph.vue?vue&type=template&id=9667611c&scoped=true", function () {
      api.rerender('9667611c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/RfDataGraph.vue"
export default component.exports